var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    viewBox: "0 0 311.533 311.533",
    xmlSpace: "preserve",
    width: "256px",
    height: "256px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fd1c1c"
    },
    d: "M273.017,311.533h-206c-8.284,0-15-6.716-15-15V15c0-8.284,6.716-15,15-15h206 c8.284,0,15,6.716,15,15v281.533C288.017,304.817,281.301,311.533,273.017,311.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2298d3"
    },
    d: "M170.017,311.533h-103c-8.284,0-15-6.716-15-15V15c0-8.284,6.716-15,15-15h103V311.533z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCDBCD"
    },
    d: "M211.044,203.269h-82.056v-27.646c0-14.681,11.901-26.582,26.582-26.582h28.891 c14.681,0,26.582,11.901,26.582,26.582V203.269z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#DCDBCD"
    },
    cx: 170.017,
    cy: 115.746,
    r: 26.044
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7B7AC"
    },
    d: "M170.017,203.269h-41.028v-27.646c0-14.681,11.901-26.582,26.582-26.582h14.446V203.269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7B7AC"
    },
    d: "M170.017,141.79c-14.384,0-26.044-11.66-26.044-26.044s11.66-26.044,26.044-26.044V141.79z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#503448"
    },
    d: "M65.517,82.776h-27c-8.284,0-15-6.716-15-15s6.716-15,15-15h27c8.284,0,15,6.716,15,15 S73.801,82.776,65.517,82.776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#503448"
    },
    d: "M65.517,141.437h-27c-8.284,0-15-6.716-15-15s6.716-15,15-15h27c8.284,0,15,6.716,15,15 S73.801,141.437,65.517,141.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#503448"
    },
    d: "M65.517,200.097h-27c-8.284,0-15-6.716-15-15s6.716-15,15-15h27c8.284,0,15,6.716,15,15 S73.801,200.097,65.517,200.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#503448"
    },
    d: "M65.517,258.757h-27c-8.284,0-15-6.716-15-15s6.716-15,15-15h27c8.284,0,15,6.716,15,15 S73.801,258.757,65.517,258.757z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo10);
export default __webpack_public_path__ + "static/media/logo10.51c37435139a5d606efcf222596a7233.svg";
export { ForwardRef as ReactComponent };